import { Injectable } from '@angular/core';
import { SLLayer } from '../model/sl-layer';
import { EnvService } from '../env.service';
import { Decorable } from '../types/decorable';

@Injectable({
	providedIn: 'root'
})
export class LegendListProviderService {


	constructor(private envService: EnvService) {

	}

	GetTreeView(layers: Array<SLLayer>) {
		const treeData = [];
		const allowedGeomTypes = ['wms','collection', 'Collection', 'point', 'polygon', 'line'];
		for (const layer of layers) {

			if (allowedGeomTypes.indexOf(layer.geom) < 0) {
				continue;
			}
			if (layer.parentLayer !== '') { continue; }
			const entry: any = this.MakeEntry(
				layer.identifier, layer.name,
				layer.icon, layer.subLayers, null,
				layer.includeInLegend ? '1' : '0', layer);

			treeData.push(entry);
		}
		treeData.sort((a: any, b: any) => {
			return this.SortFunction(a, b);
		});
		const returnVal = [{
			id: 0, type: 'heading', name: 'Legend', children: treeData, icon: '', visible: true
		}];
		return returnVal;
	}
	MakeEntry(xLayerId, xLayerName, xLayerIcon, xLayerChildren = null, xLayerType = null, vis: string, slLayer: SLLayer) {
		const entry: Decorable = {
			id: xLayerId,
			name: xLayerName,
			icon: xLayerIcon,
			visible: vis,
			layer: slLayer
		};
		if (xLayerChildren !== null) {
			entry.children = [];
			for (const child of xLayerChildren) {
				let childLayer: SLLayer;
				let identifier = slLayer.isPLayer ? child.plid : child.id;
				if (!(!!identifier)) {
					identifier = child;
				}
				childLayer = slLayer.map.GetLayerById(identifier, slLayer.isPLayer);

				entry.children.push(this.MakeEntry(
					childLayer.identifier,
					childLayer.name,
					this.envService.baseHRef + SLLayer.GetIcon(childLayer.geom),
					child.subLayers,
					null,
					'' + child.includeInLegend, childLayer));
				entry.children.sort((a: any, b: any) => {
					return this.SortFunction(a, b);
				});
			}
		}
		if (xLayerType !== null) {
			entry.type = xLayerType;
		}

		return entry;
	}
	private SortFunction(a: any, b: any) {
		if(a.id === 0) {
			return -1;
		}
		if(a.layer.IsVirtual() && !b.layer.IsVirtual()) {
			return -1;
		}
		if(!a.layer.IsVirtual() && b.layer.IsVirtual()) {
			return 1;
		}
		if(a.layer.IsVirtual() && b.layer.IsVirtual()) {
			return (a.layer.type > b.layer.type) ? 1 : -1;
		}
		if (a.name > b.name) {
			return 1;
		} else if (a.name < b.name) {
			return -1;
		}
		return 1;

	}
}
